import Svg, { Path } from 'react-native-svg';
import { withDefaultIconProps } from './index';

export const CheckBoxPositif = withDefaultIconProps(
  { height: 46, width: 47, color: '#B4ECDF' },
  ({ color = '#B4ECDF' }) => (
    <Svg width={80} height={80} viewBox="0 0 80 80" fill={color}>
      <Path
        d="M67.84 11.67C66.92 11.02 65.65 11.24 65 12.16L61.45 17.21C61.44 17.22 61.44 17.22 61.43 17.23L39.96 47.74L29.64 33.72C28.97 32.81 27.7 32.62 26.79 33.28C25.89 33.95 25.69 35.23 26.36 36.13L38.36 52.43C38.74 52.95 39.35 53.26 40 53.26C40.01 53.26 40.01 53.26 40.02 53.26C40.68 53.25 41.29 52.93 41.67 52.4L61.96 23.56V58.58C61.96 60.45 60.45 61.96 58.58 61.96H21.42C19.55 61.96 18.04 60.45 18.04 58.58V21.42C18.04 19.55 19.55 18.04 21.42 18.04H53.33C54.46 18.04 55.37 17.13 55.37 16C55.37 14.88 54.46 13.96 53.33 13.96H21.42C17.31 13.96 13.96 17.31 13.96 21.42V58.58C13.96 62.69 17.31 66.04 21.42 66.04H58.58C62.69 66.04 66.04 62.69 66.04 58.58V21.42C66.04 20.43 65.84 19.47 65.47 18.57L68.33 14.51C68.98 13.59 68.76 12.31 67.84 11.67Z"
        fill={color}
      />
    </Svg>
  ),
);
